export default {
  referenceData: {
    small: '',
    full: '',
  },
  backTo: {
    small: '',
    full: '',
  },
  legalName: {
    small: '',
    full: '',
  },
  currentData: {
    small: 'Click to select a historical version of this record.',
    full: '',
  },
  tagList: {
    small: '',
    full: '',
  },
  actionDownload: {
    small: 'Click to download this record.',
    full: '',
  },
  actionPrint: {
    small: 'Click to show a printer-friendly version of this record.',
    full: '',
  },
  actionAdd: {
    small: '',
    full: '',
  },
  actionSubscribe: {
    small: '',
    full: '',
  },
  hideBtn: {
    small: '',
    full: '',
  },
  sectionEntity: {
    small: 'This is the LEI and the legal entity\'s reference data, enabling identification, are below.',
    full: '',
  },
  sectionAddresses: {
    small: 'Official addresses of the legal entity.',
    full: '',
  },
  sectionRegistration: {
    small: 'This is information on the legal entity\'s LEI registration with the current LEI Issuer.',
    full: '',
  },
  sectionMetadata: {
    small: 'This is information on the data provided to GLEIF by the LEI Issuer for this data record.',
    full: '',
  },
  sectionLevel2: {
    small: 'This is information on legal entities related to the current LEI data record as a parent based on the consolidation of the child entity in the annuals accounts of the parent, including information on those relationships themselves.',
    full: '',
  },
  sectionLevel2Branch: {
    small: 'Information on related entities in the context of the ROC definition for International Branch',
    full: '',
  },
  sectionLevel2Parent: {
    small: 'Information on direct and ultimate parent of this legal entity based on accounting consolidation.',
    full: '',
  },
  sectionLevel2Children: {
    small: 'Information on direct and ultimate children of this legal entity based on accounting consolidation.',
    full: '',
  },
  sectionChangelog: {
    small: 'Change log tooltip',
    full: '',
  },
  l2DirectParent: {
    small: 'The "child" entity has its accounts fully consolidated by the "parent" entity, in the sense given by the accounting standard(s) specified.',
    full: 'The direct parent entity is the closest fully consolidating parent to the "child" entity in any applicable hierarchical ownership structure.',
  },
  l2UltimateParent: {
    small: 'The "child" entity is ultimately consolidated by the "parent" entity, in the sense given by the accounting standard(s) specified.',
    full: 'The ultimate parent entity is the most distant fully consolidating parent to the "child" entity in any applicable hierarchical ownership structure.',
  },
  l2DirectChildren: {
    small: '',
    full: '',
    // small: 'The "child" entity has its accounts fully consolidated by the "parent" entity,
    // in the sense given by the accounting standard(s) specified.',
    // full: 'The parent entity is the closest fully consolidating parent to the "child" entity
    // in any applicable hierarchical ownership structure.',
  },
  l2UltimateChildren: {
    small: '',
    full: '',
  // small: 'The "child" entity is ultimately consolidated by the "parent" entity, .
  // in the sense given by the accounting standard(s) specified.',
  // full: 'The  entity is the most distant fully consolidating parent from the  entity
  // in any applicable hierarchical ownership structure.',
  },
  l2Funds: {
    small: 'Information on related entities in the context of the three different definitions for fund relationships as defined by the ROC.',
    full: '',
  },
  eventsLog: {
    small: 'Legal entity events recorded for this entity.',
    full: '',

  },
  l2RelationshipDetails: {
    small: 'Relationship details for this parent.',
    full: '',
  },
  l2RelationshipDetailsFund: {
    small: 'Relationship details for this fund.',
    full: '',
  },
  l2RelationshipDetailsBranch: {
    small: 'Relationship details for this head office.',
    full: '',
  },
  l2RelationshipPeriods: {
    small: 'Tip about Relationship Periods',
    full: '',
  },
  l2RegistrationDetails: {
    small: 'Registration details for this relationship type.',
    full: '',
  },
  dataFieldLabel: {
    small: '',
    full: '',
  },
  dataFieldValue: {
    small: '',
    full: '',
  },
  btnHide: {
    small: '',
    full: '',
  },
  l2Heading: {
    small: '',
    full: '',
  },
  l2Tabs: {
    small: '',
    full: '',
  },
  l2SubHeading: {
    small: '',
    full: '',
  },
  l2DataItem: {
    small: '',
    full: '',
  },
  l2ShowAll: {
    small: '',
    full: '',
  },
  l2Graph: {
    small: 'Click on a relationship or legal entity to see more details.',
    full: '',
  },
  metaHeading: {
    small: '',
    full: '',
  },
  metaFieldLabel: {
    small: '',
    full: '',
  },
  metaValue: {
    small: '',
    full: '',
  },
  leiCodeTab: {
    small: 'Not available.',
    full: 'The LEI Code cannot be challenged if the record has Status DUPLICATE or ANNULLED.',
  },
}



// WEBPACK FOOTER //
// ./src/constants/tooltips/record.js